import { useScenarioStore } from '../../store/scenarioStore';
import type { PlanningCoupling } from '../../types/planning';

/**
 * Toggles a Trennstelle IN THE SCENARIO (measure `coupling_switch`): switching back to
 * today's state removes the measure instead of recording a no-op. Used by the map marker
 * popup and the KVS/ONS panels on the Stressszenarien page — the real grid is never switched
 * from here (that is `useCouplingSwitch` on the live map).
 */
export function toggleCouplingMeasure(c: PlanningCoupling): void {
  const { pendingMeasures, setMeasure, removeMeasure } = useScenarioStore.getState();
  const existing = pendingMeasures.find(m => m.kind === 'coupling_switch' && m.elementId === c.id);
  const target = !c.isClosed;
  if (target === c.isClosedLive) {
    if (existing) removeMeasure(existing.id);
    return;
  }
  setMeasure({ id: existing?.id ?? crypto.randomUUID(), kind: 'coupling_switch', elementId: c.id, isClosed: target });
}
